import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const categoriaProductoImporterSelectors = importerSelectors(
  'categoriaProducto.importer',
);

export default categoriaProductoImporterSelectors;
